import { render } from "./Comission.vue?vue&type=template&id=e702f0ae&scoped=true"
import script from "./Comission.vue?vue&type=script&lang=js"
export * from "./Comission.vue?vue&type=script&lang=js"

import "./Comission.vue?vue&type=style&index=0&id=e702f0ae&scoped=true&lang=less"

import exportComponent from "/Users/woniu/Desktop/woniu/web-tuiguangzu/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e702f0ae"]])

export default __exports__